module.exports = __webpack_public_path__ + "static/media/manageMySpaceGreen.71ce87d5.svg";